import { useMemo } from "react";
import { ComposableMap, Geographies, Geography } from "react-simple-maps";
import { COUNTIES } from "@/lib/constants";

const GA_TOPO = "/us-counties.json";

const SERVED = new Set(COUNTIES.map((c) => c.toLowerCase()));

export const GeorgiaMap = () => {
  // GA bounding box / projection config (Albers conic fit for Georgia)
  const projectionConfig = useMemo(
    () => ({ center: [-83.5, 32.7], scale: 6500 }),
    [],
  );

  return (
    <div className="relative w-full max-w-3xl mx-auto" data-testid="ga-map">
      <ComposableMap
        projection="geoMercator"
        projectionConfig={projectionConfig}
        width={520}
        height={620}
        style={{ width: "100%", height: "auto" }}
      >
        <Geographies geography={GA_TOPO}>
          {({ geographies }) =>
            geographies
              .filter((g) => String(g.id).startsWith("13"))
              .map((geo) => {
                const name = geo.properties?.name || "";
                const isServed = SERVED.has(name.toLowerCase());
                return (
                  <Geography
                    key={geo.rsmKey}
                    geography={geo}
                    data-testid={`county-${name.toLowerCase().replace(/\s+/g, "-")}`}
                    data-served={isServed ? "true" : "false"}
                    style={{
                      default: {
                        fill: isServed ? "#dc2626" : "#1e293b",
                        stroke: isServed ? "#fca5a5" : "#334155",
                        strokeWidth: 0.5,
                        outline: "none",
                        transition: "fill 200ms ease",
                      },
                      hover: {
                        fill: isServed ? "#ef4444" : "#334155",
                        stroke: "#ffffff",
                        strokeWidth: 0.8,
                        outline: "none",
                        cursor: isServed ? "pointer" : "default",
                      },
                      pressed: {
                        fill: isServed ? "#b91c1c" : "#334155",
                        outline: "none",
                      },
                    }}
                  >
                    <title>
                      {name} County{isServed ? " · Serviced" : ""}
                    </title>
                  </Geography>
                );
              })
          }
        </Geographies>
      </ComposableMap>
    </div>
  );
};
